export const DEFAULT_SITE_LOCALE = "en";

export interface SiteLocaleDefinition {
	locale: string;
	htmlLang: string;
	hrefLang: string;
	label: string;
	dir: "ltr" | "rtl";
	status: "live" | "planned";
}

// This order is the localization roadmap and the landing-page card order.
// It intentionally blends audience reach, SEO demand, digital-market maturity,
// and commercial value. Do not alphabetize it. Revisit it only with product or
// search data, then update the contract test in the same change.
export const SITE_LOCALES = [
	{
		locale: "en",
		htmlLang: "en",
		hrefLang: "en",
		label: "English",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "zh",
		htmlLang: "zh-CN",
		hrefLang: "zh-CN",
		label: "简体中文",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "es",
		htmlLang: "es",
		hrefLang: "es",
		label: "Español",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "pt",
		htmlLang: "pt-BR",
		hrefLang: "pt-BR",
		label: "Português",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "de",
		htmlLang: "de-DE",
		hrefLang: "de",
		label: "Deutsch",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "ja",
		htmlLang: "ja",
		hrefLang: "ja",
		label: "日本語",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "fr",
		htmlLang: "fr-FR",
		hrefLang: "fr",
		label: "Français",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "ko",
		htmlLang: "ko",
		hrefLang: "ko",
		label: "한국어",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "ar",
		htmlLang: "ar",
		hrefLang: "ar",
		label: "العربية",
		dir: "rtl",
		status: "live",
	},
	{
		locale: "id",
		htmlLang: "id-ID",
		hrefLang: "id",
		label: "Bahasa Indonesia",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "it",
		htmlLang: "it-IT",
		hrefLang: "it",
		label: "Italiano",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "hi",
		htmlLang: "hi-IN",
		hrefLang: "hi",
		label: "हिन्दी",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "zh-hant",
		htmlLang: "zh-Hant",
		hrefLang: "zh-Hant",
		label: "繁體中文",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "ru",
		htmlLang: "ru-RU",
		hrefLang: "ru",
		label: "Русский",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "tr",
		htmlLang: "tr-TR",
		hrefLang: "tr",
		label: "Türkçe",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "pl",
		htmlLang: "pl-PL",
		hrefLang: "pl",
		label: "Polski",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "nl",
		htmlLang: "nl-NL",
		hrefLang: "nl",
		label: "Nederlands",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "vi",
		htmlLang: "vi-VN",
		hrefLang: "vi",
		label: "Tiếng Việt",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "th",
		htmlLang: "th-TH",
		hrefLang: "th",
		label: "ไทย",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "fil",
		htmlLang: "fil-PH",
		hrefLang: "tl",
		label: "Filipino",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "ms",
		htmlLang: "ms-MY",
		hrefLang: "ms",
		label: "Bahasa Melayu",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "he",
		htmlLang: "he-IL",
		hrefLang: "he",
		label: "עברית",
		dir: "rtl",
		status: "live",
	},
	{
		locale: "uk",
		htmlLang: "uk-UA",
		hrefLang: "uk",
		label: "Українська",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "sv",
		htmlLang: "sv-SE",
		hrefLang: "sv",
		label: "Svenska",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "no",
		htmlLang: "nb-NO",
		hrefLang: "nb",
		label: "Norsk",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "da",
		htmlLang: "da-DK",
		hrefLang: "da",
		label: "Dansk",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "fi",
		htmlLang: "fi-FI",
		hrefLang: "fi",
		label: "Suomi",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "ro",
		htmlLang: "ro-RO",
		hrefLang: "ro",
		label: "Română",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "cs",
		htmlLang: "cs-CZ",
		hrefLang: "cs",
		label: "Čeština",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "hu",
		htmlLang: "hu-HU",
		hrefLang: "hu",
		label: "Magyar",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "el",
		htmlLang: "el-GR",
		hrefLang: "el",
		label: "Ελληνικά",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "bg",
		htmlLang: "bg-BG",
		hrefLang: "bg",
		label: "Български",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "hr",
		htmlLang: "hr-HR",
		hrefLang: "hr",
		label: "Hrvatski",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "sk",
		htmlLang: "sk-SK",
		hrefLang: "sk",
		label: "Slovenčina",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "sl",
		htmlLang: "sl-SI",
		hrefLang: "sl",
		label: "Slovenščina",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "ca",
		htmlLang: "ca-ES",
		hrefLang: "ca",
		label: "Català",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "lt",
		htmlLang: "lt-LT",
		hrefLang: "lt",
		label: "Lietuvių",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "lv",
		htmlLang: "lv-LV",
		hrefLang: "lv",
		label: "Latviešu",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "et",
		htmlLang: "et-EE",
		hrefLang: "et",
		label: "Eesti",
		dir: "ltr",
		status: "live",
	},
	{
		locale: "is",
		htmlLang: "is-IS",
		hrefLang: "is",
		label: "Íslenska",
		dir: "ltr",
		status: "live",
	},
] as const satisfies readonly SiteLocaleDefinition[];

export type SiteLocale = (typeof SITE_LOCALES)[number]["locale"];

const SITE_LOCALE_FLAG_FILES = {
	en: "us",
	ar: "sa",
	bg: "bg",
	ca: "es-ct",
	cs: "cz",
	da: "dk",
	de: "de",
	el: "gr",
	et: "ee",
	es: "es",
	fi: "fi",
	fil: "ph",
	fr: "fr",
	he: "il",
	hr: "hr",
	hu: "hu",
	hi: "in",
	id: "id",
	is: "is",
	it: "it",
	ja: "jp",
	ko: "kr",
	lt: "lt",
	lv: "lv",
	ms: "my",
	nl: "nl",
	no: "no",
	pl: "pl",
	pt: "br",
	ro: "ro",
	ru: "ru",
	sk: "sk",
	sl: "si",
	sv: "se",
	th: "th",
	tr: "tr",
	uk: "ua",
	vi: "vn",
	zh: "cn",
	"zh-hant": "tw",
} as const satisfies Record<SiteLocale, string>;

export function getSiteLocaleFlagSrc(locale: SiteLocale) {
	return `/flags/${SITE_LOCALE_FLAG_FILES[locale]}.svg`;
}

// Keep this tuple explicit. Adding a locale makes every localized pathname and
// SEO catalog require that locale at compile time before it can be published.
export const LIVE_SITE_LOCALES = [
	DEFAULT_SITE_LOCALE,
	"zh",
	"es",
	"pt",
	"de",
	"ja",
	"fr",
	"ko",
	"ar",
	"id",
	"it",
	"hi",
	"zh-hant",
	"ru",
	"tr",
	"pl",
	"nl",
	"vi",
	"th",
	"fil",
	"ms",
	"he",
	"uk",
	"sv",
	"no",
	"da",
	"fi",
	"ro",
	"cs",
	"hu",
	"el",
	"bg",
	"hr",
	"sk",
	"sl",
	"ca",
	"lt",
	"lv",
	"et",
	"is",
] as const satisfies readonly SiteLocale[];

export type LiveSiteLocale = (typeof LIVE_SITE_LOCALES)[number];

const SITE_LOCALE_BY_CODE = new Map(
	SITE_LOCALES.map((definition) => [definition.locale, definition]),
);
const LIVE_SITE_LOCALE_SET: ReadonlySet<string> = new Set(LIVE_SITE_LOCALES);

export const LIVE_SITE_LOCALE_DEFINITIONS = SITE_LOCALES.filter(
	(
		definition,
	): definition is Extract<
		(typeof SITE_LOCALES)[number],
		{ locale: LiveSiteLocale }
	> => LIVE_SITE_LOCALE_SET.has(definition.locale),
);

export function isLiveSiteLocale(value: string): value is LiveSiteLocale {
	return LIVE_SITE_LOCALE_SET.has(value);
}

export function getSiteLocaleDefinition(locale: SiteLocale) {
	const definition = SITE_LOCALE_BY_CODE.get(locale);
	if (!definition) {
		throw new Error(`Unknown site locale: ${locale}`);
	}
	return definition;
}
